<template>
  <span :class="`traveler-label`">
    <traveler-icon :traveler="traveler_info" :color="sass('primary')" />
    <span v-if="use_name">
      {{ traveler_name }}
    </span>
    <span v-else>
      Passeggero <span v-if="index >= 0">{{ index + 1 }} </span>
      <span v-else>{{ traveler_info.id }}</span>
    </span>
    <span>({{ traveler_type }})</span>
    <slot></slot>
  </span>
</template>

<script>
import { traveler_name, transcode_traveler_type } from "@liveflight/utilities";
import TravelerIcon from "./traveler-icon.vue";

export default {
  name: "traveler-label",
  components: {
    "traveler-icon": TravelerIcon,
  },
  props: {
    traveler_info: Object,
    index: {
      type: Number,
      default: () => -1,
    },
    use_name: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    traveler_type() {
      return transcode_traveler_type(this.traveler_info, 1);
    },
    traveler_name() {
      return traveler_name(this.traveler_info);
    },
  },
};
</script>

<style lang="scss" scoped>
.traveler-label {
  margin: 0;
  flex-grow: 1;
  text-align: left;

  display: flex;
  align-items: center;
  gap: 5px;
}
</style>
